import React from 'react';
import { useReveal } from '../lib/useReveal';
import { trackEvent } from '../lib/metaPixel';
const handleCheckoutClick = () => trackEvent('InitiateCheckout', {
  value: 19990,
  currency: 'ARS',
  content_name: 'MegaPack Pastelería Premium'
});
const INCLUDES = ['6 Tomos Premium', '6 Bonos Exclusivos', 'Acceso Inmediato', 'Acceso Permanente', 'Garantía de 7 días'];
export function FinalCTASection() {
  const [refPricing, visPricing] = useReveal();
  const [refClose, visClose] = useReveal();
  return <section id="cta" className="relative py-14 md:py-20 px-6 overflow-hidden bg-gradient-to-b from-[#fff8f9] via-[#fdf2f4] to-[#fce7e9]/60" data-id="element-78">
      <div className="absolute inset-0 -z-10 pointer-events-none" data-id="element-79">
        <div className="absolute top-[10%] left-[10%] w-[40%] h-[40%] rounded-full bg-[#f8d7da] blur-[120px] opacity-50" data-id="element-80"></div>
        <div className="absolute bottom-[10%] right-[10%] w-[40%] h-[40%] rounded-full bg-[#fce7e9] blur-[120px] opacity-60" data-id="element-81"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-82">
        {/* Pricing block */}
        <div ref={refPricing} className={`reveal text-center mb-8 ${visPricing ? 'is-visible' : ''}`} data-id="element-83">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-84">
            ♡ Hoy podés acceder ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-3 leading-tight" data-id="element-85">
            Hoy podés acceder al <br data-id="element-86" />
            <span className="italic text-[#e89aaa]" data-id="element-87">MegaPack completo.</span>
          </h2>
        </div>

        <div className="mb-10" data-id="element-88">
          <div className="relative bg-gradient-to-br from-white to-[#fdf2f4] rounded-[2rem] p-8 md:p-12 border-2 border-[#e89aaa]/60 shadow-[0_15px_50px_rgba(232,154,170,0.18)] flex flex-col max-w-md mx-auto" data-id="element-89">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e89aaa] text-white text-[10px] font-bold tracking-[0.25em] uppercase px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-90">
              ♡ Oferta de Lanzamiento ♡
            </span>

            <div className="text-center mb-6 mt-2" data-id="element-91">
              <h3 className="text-2xl font-serif font-bold text-[#6b4f3a] mb-4" data-id="element-92">
                MegaPack Pastelería
              </h3>

              <div className="flex flex-col items-center gap-1" data-id="element-93">
                <span className="text-[#8b6f47]/60 line-through text-base font-medium" data-id="element-94">
                  $39.990 ARS
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-95">
                  <span className="font-serif font-bold text-5xl md:text-6xl text-[#e89aaa] leading-none" data-id="element-96">
                    $19.990
                  </span>
                  <span className="text-[#8b6f47] text-sm font-medium" data-id="element-97">
                    ARS
                  </span>
                </div>
                <span className="mt-2 inline-block bg-[#fdf2f4] text-[#e89aaa] text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1 rounded-full" data-id="element-98">
                  50% OFF por tiempo limitado
                </span>
              </div>
            </div>

            <ul className="space-y-2.5 mb-6" data-id="element-99">
              {INCLUDES.map((item, i) => <li key={i} className="flex items-center gap-3 text-[#6b4f3a]" data-id="element-100">
                  <span className="w-5 h-5 rounded-full bg-[#e89aaa] flex items-center justify-center text-white text-xs shrink-0" data-id="element-101">
                    ✓
                  </span>
                  <span className="text-sm font-medium" data-id="element-102">{item}</span>
                </li>)}
            </ul>

            <a href="https://ebooksolutions.online/cart/46407716077622:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-btn block w-full px-6 py-4 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-sm md:text-base tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-103">
              QUIERO EL MEGAPACK{' '}
              <span className="font-normal opacity-90" data-id="element-104">(Compra Web)</span>
            </a>

            <a href="https://wa.me/5492613615512?text=Hola%2C%20me%20interesa%20realizar%20la%20compra%20del%20megapack%20pasteleria%20premium." target="_blank" rel="noopener noreferrer" className="cta-btn mt-3 flex items-center justify-center gap-2 w-full px-6 py-4 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white font-medium text-sm md:text-base tracking-wider text-center shadow-[0_8px_20px_rgba(37,211,102,0.3)] hover:shadow-[0_12px_25px_rgba(37,211,102,0.4)]" data-id="element-105">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="shrink-0" aria-hidden="true" data-id="element-106">
                <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.157 5.335 5.493 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.515 5.26l-.999 3.648 3.973-1.042v.235zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" data-id="element-107" />
              </svg>
              COMPRA VÍA WHATSAPP
            </a>

            <p className="text-center text-[10px] text-[#8b6f47]/70 tracking-wider uppercase mt-3" data-id="element-108">
              🔒 Pago seguro · ⚡ Acceso inmediato
            </p>
            <div className="flex justify-center mt-2" data-id="element-109">
              <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#009ee3] bg-[#009ee3]/10 border border-[#009ee3]/20 rounded-full px-3 py-1" data-id="element-110">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-111">
                  <path d="M12 2C6.48 2 2 6.03 2 11c0 2.83 1.46 5.35 3.75 7l-.6 3.5 3.3-1.83c1.07.3 2.2.46 3.55.46 5.52 0 10-4.03 10-9S17.52 2 12 2z" data-id="element-112" />
                </svg>
                Compra segura con Mercado Pago
              </span>
            </div>
          </div>
        </div>

        {/* Emotional close */}
        <div ref={refClose} className={`reveal bg-white/80 backdrop-blur-md rounded-[2rem] p-8 md:p-12 border border-[#f4b6c2]/40 shadow-[0_20px_50px_rgba(232,154,170,0.12)] text-center ${visClose ? 'is-visible' : ''}`} data-id="element-113">
          <p className="font-serif italic text-base text-[#e89aaa] mb-3" data-id="element-114">
            ♡ Tu momento es ahora ♡
          </p>

          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] mb-4 leading-tight" data-id="element-115">
            Tal vez hoy solo sea <br data-id="element-116" />
            <span className="italic text-[#e89aaa]" data-id="element-117">una pasión…</span>
          </h2>

          <p className="text-sm md:text-base text-[#8b6f47] mb-6 max-w-xl mx-auto" data-id="element-118">
            Pero con práctica, creatividad y constancia… puede convertirse en
            algo mucho más grande.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-119">
            {['Tu marca', 'Tu emprendimiento', 'Tus primeros clientes', 'Tus propias creaciones premium'].map((item, i) => <span key={i} className="inline-flex items-center gap-1.5 text-sm text-[#8b6f47] bg-[#fdf2f4] border border-[#f4b6c2]/40 rounded-full px-4 py-2" data-id="element-120">
                ✨ {item}
              </span>)}
          </div>

          <a href="https://ebooksolutions.online/cart/46407716077622:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-btn inline-block w-full sm:w-auto px-10 py-5 rounded-full bg-[#e89aaa] hover:bg-[#d98ba0] text-white font-medium text-base md:text-lg tracking-wider text-center shadow-[0_8px_20px_rgba(232,154,170,0.35)] hover:shadow-[0_12px_25px_rgba(232,154,170,0.45)]" data-id="element-121">
            QUIERO ACCEDER AL MEGAPACK ♡
          </a>

          <p className="mt-6 text-xs text-[#8b6f47]/70 tracking-wider uppercase" data-id="element-122">
            🔒 Pago seguro · ⚡ Acceso inmediato · 🛡️ Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}